module.exports = __webpack_public_path__ + "img/x.5a56d3d9.svg";